module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm._onClick
    }
  }, [_c('span', {
    staticClass: "c-btn-skew-link__bg-select u-absolute u-marg-xs u-bg--red"
  }), _vm._v(" "), _c('span', {
    staticClass: "c-btn-skew-link__text u-color--white u-relative u-marg-md"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19d26d3d"}!./src/scripts/components/app-btn-skew-link/template.html
// module id = 889
// module chunks = 0